'use strict';

/*@ngInject*/
module.exports = function sharedConfig($httpProvider) {
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    var interceptor = ['$location', '$q', '$injector', function ($location, $q, $injector) {

        return {
            'request': function request(config) {
                if (config.method == 'POST') {
                    iterateRequest(config.data);
                }
                if (config.url.substring(0, 4) !== 'http' && config.url.indexOf('.html') === -1) {
                    config.url = BASE_URL + config.url;
                }

                return config;
            },
            'response': function response(resp) {
                if (resp.status === 200 && resp.data) {
                    iterateResponse(resp.data);
                }
                return resp;
            },
            'responseError': function responseError(err) {
                //Login Timeout
                if (err.status === 440) {
                    var authService = $injector.get('authService');
                    authService.logout();
                }

                if (err.status === 500) {
                    console.error(err.data);
                    var tmp = document.createElement("DIV");
                    tmp.innerHTML = err.data;
                    var text = tmp.textContent || tmp.innerText || err.data;
                    alert(text.trim());
                }

                return $q.reject(err);
            }

        };
    }];

    $httpProvider.interceptors.push(interceptor);

    function iterateRequest(obj) {
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (angular.isDate(obj[property])) {
                    obj[property] = moment(obj[property]).format("YYYY-MM-DD");
                } else if (_.isObjectLike(obj[property])) {
                    iterateRequest(obj[property]);
                }
            }
        }
    }

    var dateRegexp = new RegExp("\\d{4}-\\d{2}-\\d{2}");
    var notDate = ['name'];

    function iterateResponse(obj) {
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (!_.includes(notDate, property) && _.isString(obj[property]) && dateRegexp.test(obj[property]) && (obj[property].length == 10 || obj[property].length == 19)) {
                    obj[property] = moment(obj[property], 'YYYY-MM-DD HH:mm:ss').toDate();
                } else if (_.isObjectLike(obj[property])) {
                    iterateResponse(obj[property]);
                }
            }
        }
    }
};


/** WEBPACK FOOTER **
 ** ./app/shared/shared.config.js
 **/